import { useContextBridge } from '@react-three/drei'
import { Canvas, Props } from '@react-three/fiber'
import React, { useContext, useEffect } from 'react'
import { ScenesContext } from './SceneProvider'
import { useScenesStore } from './store'

let ContextBridge: ({ children }: { children: React.ReactNode }) => JSX.Element
type SceneProps = {
  children: JSX.Element | JSX.Element[]
}

export const Scene = (props: Props & SceneProps) => {
  const { children, ...canvasProps } = props
  return (
    <Canvas {...canvasProps}>
      <ContextBridge>{children}</ContextBridge>
    </Canvas>
  )
}

const Scenes = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  ContextBridge = useContextBridge(ScenesContext)
  const clearGameElement = useScenesStore(s => s.clearGameElement)
  const { currentSceneIdx } = useContext(ScenesContext)

  // clears scene game elements on navigate
  useEffect(() => {
    if (currentSceneIdx !== undefined) {
      clearGameElement()
    }
  }, [currentSceneIdx])

  return <>{React.Children.toArray(children)[currentSceneIdx]}</>
}
export default Scenes
